module.exports = __webpack_public_path__ + "16fefb9e8cc872a2fb25b2a90e568092.jpg";